module.exports = __webpack_public_path__ + "img/favicon.9f0da9eb.svg";